<template>
  <div>
    <lazy-hydrate never>
      <zg-hero
        page-type="partner-page"
        :title="partnerContent.name"
        :breadcrumbs="breadcrumbs"
      />
    </lazy-hydrate>

    <zg-section
      v-if="pageContent"
      no-top-padding
    >
      <lazy-hydrate never>
        <zg-content-information>
          <template #content>
            <zg-logo-card
              v-if="partnerContent.image"
              :image="partnerContent.image"
              background="beige"
              class="partner-logo"
            />
            <rich-text :body="partnerContent.descriptionSlot" />
          </template>

          <template #aside>
            <aside-component
              v-if="pageContent.fragment"
              :component="{
                ...pageContent.fragment,
                site,
                pageType: pageContent.contentType
              }"
            />
          </template>
        </zg-content-information>
      </lazy-hydrate>
    </zg-section>

    <zg-logo-card-section
      v-if="allPartnerList"
      :items="allPartnerList.items"
      :header-title="allPartnerList.title"
      :link="allPartnerList.link"
    />
  </div>
</template>

<script>
import AsideComponent from '../components/AsideComponent.vue'
import LazyHydrate from 'vue-lazy-hydration'
import RichText from '../components/RichText.vue'

import { ZgLogoCardSection } from '@zc/components/sections/ZgLogoCardSection'
import { ZgHero } from '@zc/components/ZgHero'
import { ZgLogoCard } from '@zc/components/ZgLogoCard'
import { ZgSection } from '@zc/components/ZgSection'
import { ZgContentInformation } from '@zc/components/ZgContentInformation'

export default {
  name: 'PartnerPage',
  components: {
    AsideComponent,
    LazyHydrate,
    RichText,
    ZgLogoCardSection,
    ZgHero,
    ZgLogoCard,
    ZgSection,
    ZgContentInformation
  },
  props: {
    page: {
      type: Object,
      required: true
    },
    site: {
      type: String,
      required: true
    }
  },
  computed: {
    breadcrumbs () {
      return this.page.breadcrumbs || []
    },
    pageContent () {
      return this.page.content || {}
    },
    partnerContent () {
      return this.pageContent.partner || {}
    },
    allPartnerList () {
      return this.pageContent.allPartnerList || {}
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .partner-logo {
  margin-bottom: rhythm(base);

  @include mq(large) {
    margin-bottom: rhythm(medium);
    width: rem(350);
  }
}
</style>
